// src/pages/painel/PainelLoader.js
import React from "react";
import "./painelLoader.css";

const PainelLoader = () => {
  return (
    <div className="painel-loader-container">
      <div className="painel-loader-icone">
        <div className="loader-circle"></div>
        <div className="loader-check">✓</div>
      </div>

      <p className="painel-loader-texto">
        Conectando ao seu painel…
      </p>
    </div>
  );
};

export default PainelLoader;
